import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { getRequest as get } from 'api/utils/HttpMethods';
import { Fax } from 'interfaces';
import queryString from 'api/utils/queryStringBuilder';

export const faxQueryKeys = {
  all: ['faxes'],
  listBySite: (siteID: string) => ['faxes', siteID],
};

const listFaxesBySite = async (siteID: string): Promise<Fax[]> => {
  return await get<Fax[]>(
    'QBilling',
    `/resource/fax/site${queryString({ siteID })}`
  );
};

export const useFetchFaxesBySite = ({
  siteID,
}: {
  siteID: string;
}): UseQueryResult<Fax[], Error> => {
  return useQuery({
    queryKey: faxQueryKeys.listBySite(siteID),
    queryFn: () => listFaxesBySite(siteID),
    enabled: !!siteID,
  });
};
